export const redemptionSuccess = {
  congrats: "Congrats!",
  redeemed: "Your code has been redeemed",
  enjoyComics: "Enjoy comics on the go along with unlimited offline reading.",
};
